//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'SportradarMatch',
props: ['id', 'event', 'showStream', 'fixedMobile'],
data() {
  return {
    mode: 'scoreboard'
  }
},
computed: {
  sportradarActive() {
    return this.$store.state.sportradarActive
  },
},
filters: {

},
watch: {
  sportradarActive: function (newValue, oldValue) {
      if(newValue && oldValue != newValue) {
          this.init()
      }
  }
},
mounted() {
  if(this.sportradarActive) {
      this.init();
  }
},
methods: {
    setMode(mode) {
      this.mode = mode;
      if(mode == 'scoreboard') {
        setTimeout(() => {
          this.init()
        }, 1000)
      }
    },
    init() {
        //SIR("addWidget", ".sr-widget-lmt", "match.lmtPlus", {pitchCustomBgColor: "#387F5E", disablePitchNoise:false,disablePitchStripes:false,disablePitchOverlay:false,disablePitchSpotlights:false,pitchLightStyle:false,detailedScoreboard: "disable", demoStream:false,streamToggle: "onPitchButton", matchId: this.id});
        //SIR("addWidget", ".sr-widget-1", "match.preview", {matchId:this.id,"disableMoreStats":true});
        let mediaType = 'Double'
        if(mediaType == 'Double' && _.get(this.event, 'sportradar.lmtCoverage') == 1) {
          mediaType = 'Preview'
        }
        console.log('mediaType', _.get(this.event, 'sportradar.lmtCoverage'), mediaType)
        if(mediaType == 'Double') {
            SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {layout: "double", scoreboard: "extended", detailedScoreboard: "enable", demoStream:false,streamToggle: "streamSwitchTabs", matchId:this.id, activeSwitcher: "scoreDetails"});
        }
        if(mediaType == 'MatchTracker') {
            SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {pitchCustomBgColor: "#387F5E", disablePitchNoise:false,disablePitchStripes:false,disablePitchOverlay:false,disablePitchSpotlights:false,pitchLightStyle:false,scoreboard: "extended", momentum: "bars", collapseTo: "momentum", demoStream:false,streamToggle: "onPitchButton", matchId:this.id, detailedScoreboard: "enable", activeSwitcher: "scoreDetails"});
		    }
        if(mediaType == 'MatchTrackerLive') {
			    SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {matchId:this.id, scoreboard: "enable", momentum: "disable", layout: "double", tabsPosition: "enable", detailedScoreboard: "enable", activeSwitcher: "scoreDetails"});
		    }				
		    if(mediaType == 'Preview') {
          SIR("addWidget", ".sr-widget-1", "match.preview", {matchId:this.id,"disableMoreStats":true});
		    }				
    	  if(mediaType == 'Stats') {
			    SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {"matchId":this.id,"disableAds":true,"disablePitch":true,"momentum":"disable","scoreboard":"disable","tabsPosition":"top","ballSpottingVisibleLines":1});
		    }
		    if(mediaType == 'HeadToHead') {
          SIR("addWidget", ".sr-widget-1", "headtohead.standalone", {matchId:this.id,"layout":"inline"});
		    }
		    if(mediaType == 'Scoreboard') {
          SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {"matchId":this.id,"disableAds":true,"disableWidgetHeader":0,"disablePitch":true,"disableComponents":true,"momentum":"timeline","scoreboard":"extended","tabsPosition":"disable","activeSwitcher":"scoreDetails","detailedScoreboard":"all"});
        }
    }
  }
}
